import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './Booking.css'
import headerImg from "../../../assets/images/first page components/Navbar (2).jpg"
const Booking = () => {
  const navigate = useNavigate()
  // Same countdown state as Home page to keep them synchronized
  const [countdown, setCountdown] = useState({
    days: 2,
    hours: 0,
    minutes: 0
  })

  // Form validation state
  const [formData, setFormData] = useState({
    fullName: '',
    mobileNumber: '',
    language: '',
    dateOfBirth: '',
    placeOfBirth: '',
    emailAddress: '',
    timeHour: '',
  })

  const [errors, setErrors] = useState({})

  // Countdown timer effect - updates every second for demo
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1 }
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59 }
        } else if (prev.days > 0) {
          return { days: prev.days - 1, hours: 23, minutes: 59 }
        }
        return prev
      })
    }, 1000) // Update every second for demo

    return () => clearInterval(timer)
  }, [])

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // Validate form
  const validateForm = () => {
    const newErrors = {}
    
    if (!formData.fullName.trim()) {
      newErrors.fullName = 'Full Name is required'
    }
    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile Number is required'
    } else if (!/^[0-9]{10}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Mobile Number must be exactly 10 digits'
    }
    if (!formData.dateOfBirth) {
      newErrors.dateOfBirth = 'Date of Birth is required'
    } else {
      // Check if date is not in the future
      const selectedDate = new Date(formData.dateOfBirth)
      const today = new Date()
      today.setHours(23, 59, 59, 999) // End of today
      if (selectedDate > today) {
        newErrors.dateOfBirth = 'Date of Birth cannot be in the future'
      }
      // Check if date is not too far in the past (reasonable age range)
      const minDate = new Date()
      minDate.setFullYear(minDate.getFullYear() - 120) // 120 years ago
      if (selectedDate < minDate) {
        newErrors.dateOfBirth = 'Date of Birth seems invalid'
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleContinue = (e) => {
    e.preventDefault()
    
    if (validateForm()) {
      // All fields are valid, proceed to next page
      console.log('Form submitted successfully:', formData)
      navigate('/consultation-slots', { 
        state: { 
          userLanguage: formData.language 
        } 
      })
    } else {
      // Form has errors, don't proceed
      console.log('Form validation failed')
    }
  }

  // 7-segment digit rendering function (same as Home page)
  const renderDigit = (digit) => {
    const segments = {
      0: ['a', 'b', 'c', 'd', 'e', 'f'],
      1: ['b', 'c'],
      2: ['a', 'b', 'd', 'e', 'g'],
      3: ['a', 'b', 'c', 'd', 'g'],
      4: ['b', 'c', 'f', 'g'],
      5: ['a', 'c', 'd', 'f', 'g'],
      6: ['a', 'c', 'd', 'e', 'f', 'g'],
      7: ['a', 'b', 'c'],
      8: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
      9: ['a', 'b', 'c', 'd', 'f', 'g']
    };
    
    const activeSegments = segments[digit] || [];
    
    return (
      <>
        <div className={`segment-a ${activeSegments.includes('a') ? 'active' : ''}`}></div>
        <div className={`segment-b ${activeSegments.includes('b') ? 'active' : ''}`}></div>
        <div className={`segment-c ${activeSegments.includes('c') ? 'active' : ''}`}></div>
        <div className={`segment-d ${activeSegments.includes('d') ? 'active' : ''}`}></div>
        <div className={`segment-e ${activeSegments.includes('e') ? 'active' : ''}`}></div>
        <div className={`segment-f ${activeSegments.includes('f') ? 'active' : ''}`}></div>
        <div className={`segment-g ${activeSegments.includes('g') ? 'active' : ''}`}></div>
      </>
    );
  };

  return (
    <div className="booking-page home-layout-bg">
      <img 
        src={headerImg}
        alt="AstroCure Navbar" 
        className="navbar-image"
      />

      <main className="main-content">
        <div className="top-section">
          <h1 className="main-title">
            <span className="title-purple">Share Your</span>
            <span className="title-white"> Details & Choose A Time</span>
          </h1>
          
          <p className="sub-headline">
            Your stars hold the answers. Connect with an authentic astrologer for a 15-minute consultation<br />
            — no charges, just guidance. ✨
          </p>

          <div className="digital-countdown-timer">
            <div className="timer-section">
              <div className="digit-pair">
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(Math.floor(countdown.days / 10))}
                  </div>
                </div>
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(countdown.days % 10)}
                  </div>
                </div>
              </div>
              <div className="timer-label">DAYS</div>
            </div>
            <div className="timer-section">
              <div className="digit-pair">
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(Math.floor(countdown.hours / 10))}
                  </div>
                </div>
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(countdown.hours % 10)}
                  </div>
                </div>
              </div>
              <div className="timer-label">HOURS</div>
            </div>

            {/* Minutes Section */}
            <div className="timer-section">
              <div className="digit-pair">
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(Math.floor(countdown.minutes / 10))}
                  </div>
                </div>
                <div className="digit-module">
                  <div className="digit-segment">
                    {renderDigit(countdown.minutes % 10)}
                  </div>
                </div>
              </div>
              <div className="timer-label">MINUTES</div>
            </div>
          </div>
        </div>
          <p className="slot-availability">
            ⏳ Choice-of-Choice  Only <span style={{color: "#CF75F9"}}>24 slots</span> pending! 
          </p>
           <p className="first-come-text"> First come, First served. </p>

          

        <div className="form-container schedule-section">
          <h2 className="booking-form-title">Schedule Your Free Consultation</h2>
          <form className="booking-consultation-form">
              <div className="form-column">
                <div className="form-group">
                  <input 
                    type="text" 
                    id="fullName" 
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="Enter your full name"
                    required
                  />
                  {errors.fullName && <p className="error-message">{errors.fullName}</p>}
                  <label htmlFor="fullName">Full Name</label>
                </div>

                <div className="form-group">
                  <input 
                    type="date" 
                    id="dateOfBirth" 
                    name="dateOfBirth"
                    value={formData.dateOfBirth}
                    onChange={handleInputChange}
                    max={new Date().toISOString().split('T')[0]}
                    required
                  />
                  {errors.dateOfBirth && <p className="error-message">{errors.dateOfBirth}</p>}
                  <label htmlFor="dateOfBirth">Date of Birth</label>
                </div>

                <div className="form-group">
                  <input 
                    type="tel" 
                    id="mobileNumber" 
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    placeholder="Enter your mobile number"
                    required
                    pattern="[0-9]{10}"
                    maxLength="10"
                  />
                  {errors.mobileNumber && <p className="error-message">{errors.mobileNumber}</p>}
                  <label htmlFor="mobileNumber">Mobile Number</label>
                </div>
            </div>

            <div className="checkbox-group">
              <input 
                type="checkbox" 
                id="mandatoryFields" 
                checked={true}
                readOnly
                disabled
              />
              <label htmlFor="mandatoryFields">All Fields are mandatory</label>
            </div>
            <button type="submit" className="continue-button" onClick={handleContinue}>
              Continue 👉
            </button>
            <p className="proceeding-text">
              By proceeding, you accept our
              <span
                style={{ color: "#7611AE", cursor: "pointer"}}
                onClick={() => {
                  window.open("/terms-and-conditions");
                }}
              >
               {" "} Terms & Conditions
              </span>
            </p>
          </form>
        </div>

        {/* Back to Home Link */}
        <div className="back-link">
          <Link to="/free-campaign" className="back-btn">
            ← Back to Home
          </Link>
        </div>
      </main>
    </div>
  )
}

export default Booking
